import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { Alert, CircularProgress } from '@mui/material';
import { IPlaylistDataDto } from '../clients/services';
import { MainContent, MainNarrow } from '../components';
import { RightColumn } from '../components/RightColumn';
import TicketReservationSide from '../components/TicketReservationSide';
import { PlaylistPublicService } from '../services';

const playlistPublicService = new PlaylistPublicService();

export const Playlists = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [playlists, setPlaylists] = useState<IPlaylistDataDto[]>([]);

    const loadPlaylists = async () => {
        setIsLoading(true);
        setError('');
        try {
            const result = await playlistPublicService.loadNewestThreePlaylistsAsync();
            setPlaylists(result);
        } catch {
            setError('Playlists konnten nicht geladen werden.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadPlaylists();
    }, []);

    return (
        <>
            <MainContent>
                <MainNarrow>
                    <h1>MARTIN&apos;S PLAYLISTS</h1>
                    {isLoading && <CircularProgress />}
                    {error && <Alert severity="error">{error}</Alert>}
                    {playlists.map((p) => (
                        <div key={p.year + '-' + p.month} style={{ marginBottom: 20 }}>
                            <h2>
                                {p.month ? (
                                    <>
                                        Martin&apos;s Playlist,{' '}
                                        {DateTime.fromObject({ year: p.year, month: p.month }).toFormat('LLLL')}{' '}
                                        {p.year}
                                    </>
                                ) : (
                                    <>Martin’s Favorite Albums {p.year}</>
                                )}
                            </h2>
                            {p.image && (
                                <img
                                    src={playlistPublicService.resolveImageUrl(p.image)}
                                    alt="NumberOne"
                                    style={{ marginBottom: 20, width: 340 }}
                                />
                            )}
                            <table>
                                <tbody>
                                    {p.playlist.map((i, k) => (
                                        <tr key={i.artist + i.title + k}>
                                            {k === 0 ? (
                                                <>
                                                    {p.month && (
                                                        <td className="width-10">
                                                            <strong className="color2">1</strong>
                                                        </td>
                                                    )}
                                                    <td className="width-40">
                                                        <strong>{i.artist}</strong>
                                                    </td>
                                                    <td className="width-50">{i.title}</td>
                                                </>
                                            ) : (
                                                <>
                                                    {p.month && <td>{k + 1}</td>}
                                                    <td>
                                                        <strong>{i.artist}</strong>
                                                    </td>
                                                    <td>{i.title}</td>
                                                </>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ))}
                </MainNarrow>
                <RightColumn>
                    <TicketReservationSide />
                </RightColumn>
            </MainContent>
        </>
    );
};

export default Playlists;
